import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/knowledge/customization")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/settings/customization" search={{ tab: "agent" }} replace />
}
